export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND'
export const PHONE_NOT_FOUND = 'No user found with this phone'
export const ORGANIZATION_DISABLED = 'ORGANIZATION_DISABLED'
export const NO_INTERNET_CONNECTION = 'No internet connection'
export const NO_USER_FOUND_WITH_THIS_EMAIL = 'No user found with this email'

export const SELECT_NEW_PROTRACK_PARAM = 'selectnewprotrack'
export const INVALID_TOKEN_PARAM = 'invalid_token'
